import { FC, useState } from "react";

import { copy } from "shared/assets";
import { Hotel } from "shared/assets/icons";
import { Card, Modal } from "shared/components";
import { EditUserHotelPreferencesForm, UserHotelPreferences } from "Bands/containers";

const hotelCopy = copy.userHotelPreferences;

export const HotelPreferences: FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Card icon={Hotel} title={hotelCopy.title}>
      <UserHotelPreferences handleShowModal={setShowModal} />
      {showModal && (
        <Modal icon={Hotel} title={hotelCopy.title} handleClose={() => setShowModal(false)}>
          <EditUserHotelPreferencesForm handleClose={() => setShowModal(false)} />
        </Modal>
      )}
    </Card>
  );
};
